import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography, Button, Popper, Paper, ClickAwayListener, MenuList, MenuItem
} from '@material-ui/core';
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const MainNavbar = (props) => {
  const navigate = useNavigate();
  const { title, userStore } = props;

  const [openedMenu, setOpenedMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const pages = [
    {
      title: 'LANÇAMENTOS DE LIVROS',
      url: '/app/book-releases'
    },
    {
      title: 'Cadastro de Livros',
      id: '/app/books',
      childs: [
        {
          title: 'Lista de Livros-Filho',
          url: '/app/books/list'
        },
        {
          title: 'Lista de Livros-Pai',
          url: '/app/main/books'
        },
        {
          title: 'Criar Novo Livro-Filho',
          url: '/app/books/create'
        },
        {
          title: 'Criar Novo Livro-Pai',
          url: '/app/main/books/create'
        },
        {
          type: 'divider'
        },
        {
          title: 'Gerenciar Tags',
          url: '/app/tags'
        }
      ]
    },
    {
      title: 'Cadastro de Autores',
      id: '/app/authors',
      childs: [
        {
          title: 'Lista de Autores-pai',
          url: '/app/main/authors'
        },
        {
          title: 'Criar Novo Autor-pai',
          url: '/app/main/authors/create'
        }
      ]
    },
    {
      title: 'Interações com usuários',
      id: '/app/automation',
      childs: [
        {
          title: 'Interações com usuário fictício',
          url: '/app/automation'
        },
        {
          title: 'Envio de Pushes',
          url: '/app/automation/pushes'
        }
      ]
    },
    {
      title: 'Relatórios',
      url: '/app/reports'
    }
  ];

  if (userStore && userStore.isLoggedIn) {
    pages.push({
      title: 'Sair',
      onClick: async () => {
        await userStore.logout();
        navigate('/', { replace: true });
      }
    });
  }

  const handleOpenMenu = (target, id) => {
    setAnchorEl(target);
    setOpenedMenu(id);
  };

  const handleClose = () => {
    setOpenedMenu(null);
    setAnchorEl(null);
  };

  const handleClickAway = (id) => {
    if (openedMenu === id) {
      handleClose();
    }
  };

  const submenu = (page) => (
    <Popper open={openedMenu === page.id} anchorEl={anchorEl} placement='bottom-start' disablePortal>
      <Paper>
        <ClickAwayListener onClickAway={() => handleClickAway(page.id)}>
          <MenuList>
            {page.childs.map((el, index) => (
              el.type === 'divider' ? (
                <div key={`divider-${index}`} style={{ borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
              ) : (
                <MenuItem 
                  key={el.url ?? el.title} 
                  onClick={() => {
                    if (el.url) {
                      navigate(el.url);
                      return;
                    }

                    if (el.onClick) {
                      el.onClick();
                    }
                  }}
                >
                  {el.title}
                </MenuItem>
              )
            ))}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );

  return (
    <AppBar position='fixed' component='nav'>
      <Toolbar>
        <Typography sx={{ flexGrow: 1 }} variant='h3' gutterBottom>{title}</Typography>
        {pages.map(page => (
          <div key={`div-${page.id ?? page.url}`}>
            <Button key={page.id ?? page.url} sx={{ color: '#fff' }}
                    onClick={(event) => {
                      if (page.onClick) {
                        page.onClick();
                        return;
                      }

                      if (page.url) {
                        navigate(page.url);
                        return;
                      }

                      if (page.childs) {
                        handleOpenMenu(event.currentTarget, page.id);
                      }
                    }}
            >
              {page.title}
              {page.childs && <KeyboardArrowDownIcon />}
            </Button>
            {page.childs !== undefined && submenu(page)}
          </div>
        ))}
      </Toolbar>
    </AppBar>
  );
};

export default MainNavbar;
